import { css, StyleSheet } from 'aphrodite/no-important';
import * as React from 'react';
import { MediaBreakPointUp } from '@lean-body/components/styles';
export class FullWidthLayout extends React.Component {
    render() {
        return React.createElement("div", { className: this.containerClass }, this.props.children);
    }
    get containerClass() {
        return [this.props.className || '', css(this.styles.container)].join(' ');
    }
    get styles() {
        return StyleSheet.create({
            container: {
                backgroundImage: this.props.noBackground ? '' : 'url("/assets/images/backgrounds/1.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100%',
                overflowY: 'scroll',
                padding: this.props.noPadding ? '0' : '1.5rem 0',
                '-webkit-overflow-scrolling': 'touch',
                ':before': {
                    position: 'fixed',
                    content: this.props.noBackground ? '' : '" "',
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                },
                [MediaBreakPointUp.SM]: {
                    padding: this.props.noPadding ? '0' : '3rem 0',
                },
            },
        });
    }
}
